import { createFeatureSelector, createSelector } from '@ngrx/store';
import { USER_FEATURE_KEY, UserState } from './user.reducer';
export const selectUserState =
  createFeatureSelector<UserState>(USER_FEATURE_KEY);

export const selectNavigationItems = createSelector(
  selectUserState,
  (state: UserState) => state.navigationItems,
);

export const selectShowWalkthrough = createSelector(
  selectUserState,
  (state: UserState) => state.showWalkthrough,
);
